import React, { useState } from 'react';
import { api } from '../services/api';
import '../styles/Categories.css';

// Composant pour gérer les catégories (création, édition, suppression)
function Categories({ cats, loadAll }) {
  // Etats pour créer une nouvelle catégorie
  const [newCat, setNewCat] = useState(''); // Nom
  const [newColor, setNewColor] = useState('#000000'); // Couleur

  // Etats pour éditer une catégorie existante
  const [editingId, setEditingId] = useState(null); // ID de la cat en cours de modification
  const [editName, setEditName] = useState(''); // Nouveau nom
  const [editColor, setEditColor] = useState(''); // Nouvelle couleur

  // Crée une nouvelle catégorie
  const addCat = async () => {
    if(newCat) { 
        await api.addCat(newCat, newColor); // Appel API
        setNewCat(''); // Réinitialise le champ
        loadAll(); // Recharge les catégories
    }
  };

  // Supprime une catégorie après confirmation
  const delCat = async (id) => { 
      if(window.confirm('Voulez-vous supprimer cette catégorie ?')) { 
        await api.deleteCat(id); 
        loadAll(); 
      } 
  };

  // Passe une catégorie en mode édition
  const startEditing = (category) => {
    setEditingId(category.id);
    setEditName(category.name);
    setEditColor(category.color);
  };

  // Annule l'édition et revient en mode affichage
  const cancelEditing = () => {
    setEditingId(null);
    setEditName('');
    setEditColor('');
  };

  // Sauvegarde les modifications d'une catégorie
  const saveEdit = async () => {
    if(editName) {
        // Appel API pour mettre à jour
        await api.updateCat({
            id: editingId,
            name: editName,
            color: editColor
        });
        setEditingId(null); // Quitte le mode édition
        loadAll(); // Recharge les catégories
    }
  };

  return (
    <div className="box">
      <h3>Catégories</h3>
      
      {/* FORMULAIRE D'AJOUT (Inchangé) */}
      <div className="category-form">
        <input 
            placeholder="Nom de la catégorie..." 
            value={newCat} 
            onChange={e=>setNewCat(e.target.value)} 
        />
        <input 
            type="color" 
            value={newColor} 
            onChange={e=>setNewColor(e.target.value)} 
        />
        <button onClick={addCat}>➕ Créer</button>
      </div>

      {/* LISTE DES CATÉGORIES */}
      <div className="categories-container">
          {cats.map(c => (
            <React.Fragment key={c.id}>
                {editingId === c.id ? (
                    // --- MODE ÉDITION (Inputs) ---
                    <div 
                        className="category-item category-item-editing"
                    >
                        <input 
                            value={editName} 
                            onChange={e=>setEditName(e.target.value)}
                            className="category-edit-input"
                        />
                        <input 
                            type="color" 
                            value={editColor} 
                            onChange={e=>setEditColor(e.target.value)}
                            className="category-edit-color"
                        />
                        {/* Boutons save / Annuler */}
                        <button onClick={saveEdit} className="category-edit-save" title="Sauvegarder">✓</button>
                        <button onClick={cancelEditing} className="category-edit-cancel" title="Annuler">❌</button>
                    </div>
                ) : (
                    // affichage
                    <div 
                      className="category-item"
                      style={{background: c.color}}
                    >
                      {c.name}
                      
                      {/* Groupe de boutons (Modifier / Supprimer) */}
                      <div className="category-actions">
                          <button 
                            onClick={() => startEditing(c)}
                            className="category-edit-btn"
                            title="Modifier"
                          >
                            ✏️
                          </button>
                          <button 
                            className="category-delete-btn" 
                            onClick={()=>delCat(c.id)}
                            title="Supprimer"
                          >
                            ✕
                          </button>
                      </div>
                    </div>
                )}
            </React.Fragment>
          ))}
      </div>
    </div>
  );
}

export default Categories;